<nav #navbar class="navbar">
  <div class="container-fluid">
    <div class="navbar-header d-flex align-items-center flex-row-reverse" style="padding: 0; border-right:unset">
      <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <!-- <a class="navbar-brand" routerLink="/page/home" style="margin:auto; height: 60px;">
        <img src="assets/images/4signing3.png" alt="" />
        <span class="logo-name">{{"SystemTitle" | translate}}</span>
      </a> -->
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <a class="navbar-brand show-logo" id="big-Logo" style="height: 60px;" routerLink="/page/home">
        <img src="assets/images/learnyhome1.png" alt=""
          style="height: 90% ; width: 90%; margin: 2px auto; float: none;" />
        <!-- <span class="logo-name my-auto">{{"SystemTitle" | translate}}</span> -->
      </a>
      <a class="navbar-brand hide-logo" id="small-Logo" style=" height: 60px;">
        <img src="assets/images/learnyhome2.png" alt="" style="width: 80%; float: none;" />
        <span class="logo-name my-auto">{{"SystemTitle" | translate}}</span>
      </a>
    </div>
    <div class="collapse navbar-collapse" id="collapse " [ngbCollapse]="isNavbarCollapsed">
      <ul class="pull-left collapse-menu-icon">
        <li>
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
            <i class="nav-hdr-btn ti-align-left"></i>
          </button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <!-- Full Screen Button -->

        <li *ngIf="this.authService.user.id===1" class="fullscreen">
          <button mat-icon-button routerLink="/page/schools" class=" nav-notification-icons">
            <i class="fas fa-school"></i>
          </button>
        </li>
        <li class="fullscreen">
          <button mat-icon-button (click)="callFullscreen()" class=" nav-notification-icons">
            <i class="nav-hdr-btn ti-fullscreen"></i>
          </button>
        </li>
        <li class="nav-item">
          <a class="lang">
            <button (click)="changeLang()" id="language">English</button>
          </a>
        </li>

        <!-- <li class="nav-item dropdown-notifications" ngbDropdown id="dropdown-notifications">
          <button mat-icon-button ngbDropdownToggle class="nav-notification-icons">
            <i class="nav-hdr-btn ti-bell"></i>
             <span class="notify"></span>
            <span class="heartbeat"></span>
            <span class="notification"
              *ngIf="0<numberOfNotifications && numberOfNotifications<6">{{numberOfNotifications}}</span>
            <span class="notification over_5" *ngIf="6 <= numberOfNotifications">5+</span>
          </button>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 250px;" [perfectScrollbar]>
              <ul class="menu">
                <li *ngFor="let notification of notifications  , let i = index"
                  (click)="ViewRequest(notification.dataUrl)">
                  <a *ngIf="i<6" class="notification-item">
                    <div class="notification-content d-flex justify-content-between align-items-start">
                      <div class="notification-detalis">
                        <p class="notification-name m-0">{{notification.name}}</p>
                        <p class="notification-describtion">{{notification.describtion}}</p>
                      </div>
                      <span class="notification-time d-flex align-items-center">
                        <i class="material-icons mx-2">access_time</i> {{notification.hours}} {{'hour' | translate}}
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <a class="text-center d-block border-top py-1" (click)="closeDropDown('/page/view-all-notifications')"
              style="color: var(--subColor);">
              {{'readAllNotifications' | translate}}</a>
          </div>
        </li> -->
        <!-- #END# Notifications-->
        <li class="nav-item user_profile" ngbDropdown>
          <a href="#" onClick="return false;" ngbDropdownToggle role="button" class="nav-notification-icons pt-0">
            <img src="assets/images/user.jpg" class="rounded-circle" width="32" height="32" alt="User">
          </a>
          <div ngbDropdownMenu class="notification-dropdown pullDown ">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 300px;" [perfectScrollbar]>
              <ul class="menu">
                <li class="body">
                  <ul class="user_dw_menu">
                    <li (click)="closeDropDown('/page/Profile')">
                      <!-- <li (click)="closeDropDown('/page/Profile')"> -->

                      <a href="#" onClick="return false;" style="font-size: larger">
                        <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>{{'Password Change' | translate}}
                      </a>
                    </li>
                    <!-- <li> -->
                    <!-- <a href="#" onClick="return false;">
                        <mat-icon aria-hidden="false" class="mr-2">feedback</mat-icon>Feedback
                      </a> -->
                    <ol style="border-bottom: 1px solid #eee;">
                      <!-- <strong style="font-size: larger">My Schools</strong> -->
                      <li class="items" *ngFor="let school of mySchools"><a style="font-size: larger; "
                          [ngClass]="{'active' : defaultSchool== school.name}"
                          (click)="show(school.id)">{{ "- "+ school.name}}</a></li>
                    </ol>
                    <!-- </li> -->
                    <!-- <li> -->
                    <!-- <a href="#" onClick="return false;">
                        <mat-icon aria-hidden="false" class="mr-2">help</mat-icon>Help
                      </a>
                    </li> -->
                    <li>
                      <a href="javascript:void(0);" (click)="logout()" style="font-size: larger">
                        <mat-icon aria-hidden="false" class="mr-2">power_settings_new</mat-icon>{{'logout' | translate}}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <!-- #END# Tasks -->
        <!-- <li class="pull-right">
          <button mat-icon-button (click)="toggleRightSidebar()" class="nav-notification-icons">
            <i class="nav-hdr-btn ti-layout-grid2" id="settingBtn"></i>
          </button>
        </li> -->
      </ul>
    </div>
  </div>
</nav>
